import request from '@/utils/httpRequest'

export default class NewContractsService {
    queryById (id) {
        return request({
            url: '/contract/shyeContract/queryById',
            method: 'get',
            params: {id: id}
        })
    }
    startFlow (params) {
        return request({
            url: '/contract/shyeContract/startFlow',
            method: 'post',
            data: params
        })
    }
    queryByChangeId (id) {
        return request({
            url: '/contract/shyeContractChange/queryById',
            method: 'get',
            params: {id: id}
        })
    }
    startFlowChange (params) {
        return request({
            url: '/contract/shyeContractChange/startFlow',
            method: 'post',
            data: params
        })
    }
	queryByCustomer (customerId,id) {
	    return request({
	        url: '/contract/shyeContract/queryByCustomer',
	        method: 'get',
	        params: {customerId:customerId,id: id}
	    })
	}
}
